/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_ConcretingRequestMessage } from "@graphql/helpers/types.graphql";
import { CommandResult } from "@graphql/groups/fragment.graphql";
import utils, {
  TNonEmptyArray,
  TConcretingRequestMessageType
} from "@graphql/helpers/utils.graphql";

type TConcretingRequestMessageCreateFunctions = {
  create: CommandResult_ConcretingRequestMessage;
};
export type TConcretingRequestMessageCreateMutations = {
  concretingRequestMessage: TConcretingRequestMessageCreateFunctions;
};
export const concretingRequestMessageCreate = (
  fields: TNonEmptyArray<TConcretingRequestMessageType>
) => gql`
  mutation concretingRequestMessageCreate($concretingRequestMessage: ConcretingRequestMessageCreateInputType!) {
    concretingRequestMessage {
      create(concretingRequestMessage: $concretingRequestMessage) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ConcretingRequestMessage")}
`;

type TConcretingRequestMessageUpdateFunctions = {
  update: CommandResult_ConcretingRequestMessage;
};

export type TConcretingRequestMessageUpdateMutations = {
  concretingRequestMessage: TConcretingRequestMessageUpdateFunctions;
};
export const concretingRequestMessageUpdate = (
  fields: TNonEmptyArray<TConcretingRequestMessageType>
) => gql`
  mutation concretingRequestMessageUpdate($concretingRequestMessage: ConcretingRequestMessageUpdateInputType!) {
    concretingRequestMessage {
      update(concretingRequestMessage: $concretingRequestMessage) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ConcretingRequestMessage")}
`;
